import React, { useCallback } from 'react'
import { Col, Row } from 'react-bootstrap'
import ChipsInputField from '../../components/Field/ChipsInput'
import { useConfigDataState } from '../../globalStates/ConfigDataState'
import { useLanguageState } from '../../globalStates/LanguageState'

interface KeywordContentsProps {
    value: readonly string[]
    onChange: (value: unknown) => void
}

const KeywordContents: React.FC<KeywordContentsProps> = ({ value, onChange }) => {
    const branding = useLanguageState().getStrings()
    const serviceKeys = useConfigDataState().getServiceKeys()
    const onChangeHandler = useCallback((chips: Array<string>) => {
        onChange(chips)
    }, [onChange])
    return (
        <Row>
            <Col>
                <ChipsInputField
                    id="ks_keywords"//TODO - check this id 
                    label={branding.configuration.profilePage.sctKeywords.lblKeywords}
                    placeholder={branding.configuration.hntChips}
                    value={value}
                    limit={serviceKeys.keywords || 0}
                    onChange={onChangeHandler}
                />
            </Col>
        </Row>
    );
}

export default KeywordContents